module.exports = __webpack_public_path__ + "static/media/searchSvg.62cab9aa.svg";